<template>
    <div>
      <GetWallet ></GetWallet>
    </div>
</template>

<script>
import GetWallet from "./wallet/Get.vue";


export default {
    components: {
        GetWallet
    },
    data() {
        return {}
    },
    methods: {

    },
    computed: {
    },
    mounted() {
    }
}
</script>

<style>

</style>